import application from '$shared/lib/events/application';
import type {
  IUnauthorizedListener,
  IUserOrgChangeListener
} from '$shared/interfaces/IEventListener';
import ServiceErrorWrapper from '$shared/helpers/decorators/ServiceErrorWrapper';
import type BaseStore from '$shared/stores/BaseStore';
import type ServiceError from '$shared/models/ServiceError';

export default abstract class BaseService implements IUnauthorizedListener, IUserOrgChangeListener {
  constructor() {
    application.addUnAuthorizationEventListener(this);
    application.addUserOrgChangeEventListener(this);
  }

  abstract onUserUnauthorized(): void;
  abstract onUserOrgChanged(): void;

  protected getStore(): BaseStore<unknown> | undefined {
    return;
  }

  @ServiceErrorWrapper()
  protected async handleErrorAsync<T = void>(apiReq: () => Promise<T>): Promise<T | undefined> {
    const store = this.getStore();
    try {
      store?.setLoading(true);
      return await apiReq();
    } catch (err: unknown) {
      store?.setError(err as ServiceError);
      throw err;
    } finally {
      store?.setLoading(false);
    }
  }
}
